import { createContainer } from "unstated-next";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { initAdminTree } from "project-config/utils";

export interface IAllPermission {
  id: number;
  authority: string;
  children: IAllPermission[];
  module: string;
  pid: number;
  remark: string;
  url: string;
}

function usePermissionHook() {
  const [allPermission, setAllPermission] = useState<IAllPermission[]>([]);
  const [permissionList, setPermissionList] =
    useState<IPermissionList | null>();

  const { data } = useQuery<IAllPermission[]>(
    "/api/rendering/user/userAuth/queryAllUserPermission"
  );

  const getPermissionList = (permission: IAllPermission[]) => {
    const userPermission = JSON.parse(JSON.stringify(permission));
    initAdminTree(userPermission);
    const list: IPermissionList = {};
    function flatArray(arr: typeof userPermission) {
      arr.forEach((v: IPermissionChildren) => {
        const { name, parameters, status, children } = v;
        list[name] = {
          status,
          parameters,
          children,
        };
        if (children) {
          flatArray(children);
        }
      });
    }
    flatArray(userPermission);
    userPermission.forEach((v: IPermissionChildren) => {
      if (!v.children) list[v.name].status = true;
      else {
        v.children.forEach((vc) => {
          if (!vc.children) {
            list[vc.name].children = undefined;
          }
        });
      }
    });
    return list;
  };

  const checkNoPermission = useCallback(
    (value: string) => {
      const noPermission =
        !permissionList ||
        !permissionList[value] ||
        !permissionList[value].status;
      return noPermission ? "global-no-permission" : "";
    },
    [permissionList]
  );

  useEffect(() => {
    setAllPermission(data ?? []);
  }, [data]);

  useEffect(() => {
    setPermissionList(getPermissionList(allPermission));
  }, [allPermission]);

  return {
    allPermission,
    setAllPermission,
    checkNoPermission,
  };
}

const PermissionStoreContainer = createContainer(usePermissionHook);
export const PermissionStoreProvider = PermissionStoreContainer.Provider;

export function usePermissionStore() {
  return PermissionStoreContainer.useContainer();
}

export interface IPermissionChildren {
  children?: IPermissionChildren[];
  display: any;
  id: number;
  name: string;
  parameters: string;
  status: boolean;
  text: string;
  treeIndex: string;
  type: any;
  url: string;
  verify: any;
}

export interface IPermissionItem {
  children?: IPermissionChildren[];
  parameters: string;
  status: boolean;
}

export interface IPermissionList {
  [key: string]: IPermissionItem;
}
